import { createDeepEqualSelector } from '../../../../../helpers/memoizeHelper';
import { EMPTY_ARRAY, IApplicationState, TBoardId, TCardId, TCustomPropertyId } from '../../../../../../../types/types';
import {
    ECustomPropertyType,
    IBoardCardCustomProperties,
    ICardCustomProperties
} from '../../../../../../../store/customProperties/types';
import { getCardCustomProperties } from '../../../../../../../store/model/selectors/getCardCustomProperties';
import {
    getBoardCardCustomProperties
} from '../../../../../../../store/model/board/selectors/getBoardCardCustomProperties';
import {
    getCardPinnedCustomPropertiesIds
} from '../../../../../../../store/model/selectors/getCardPinnedCustomPropertiesIds';
import {
    getBoardCardRequiredCustomPropertyIds
} from '../../../../../../../store/model/board/selectors/getBoardCardRequiredCustomPropertyIds';
import { ICustomPropertiesElement } from '../../components/CustomProperty/types';
import {
    getBoardCardCustomPropertyOptions
} from '../../../../../../../store/model/board/selectors/getBoardCardCustomPropertyOptions';

type TgetCustomProperties = (
    state: IApplicationState,
    boardId: TBoardId,
    cardId: TCardId,
    isKnbPinned?: boolean, // для канбан карты
    showCustomProperties?: TCustomPropertyId[], // для канбан карты
) => ICustomPropertiesElement[];

const getCustomPropertiesSelector = (
    boardCustomProperties: IBoardCardCustomProperties,
    defaultCustomPropertyIds: TCustomPropertyId[],
    isRequiredCustomPropertyIds: Set<TCustomPropertyId>,
    cardCustomProperties: ICardCustomProperties,
    customPropertiesPinnedOnCard: TCustomPropertyId[],
    isKnbPinned?: boolean,
    showCustomProperties?: TCustomPropertyId[],
): ICustomPropertiesElement[] => {
    if (isKnbPinned && (!showCustomProperties || !showCustomProperties.length) && !customPropertiesPinnedOnCard.length) return EMPTY_ARRAY;

    const customProperties: ICustomPropertiesElement[] = [];

    for (let id in boardCustomProperties) {
        const property = boardCustomProperties[id];
        let value = cardCustomProperties[id] ? cardCustomProperties[id].value : null;
        const pinned = defaultCustomPropertyIds.includes(id);
        const pinnedOnCard = customPropertiesPinnedOnCard.includes(id);
        const isRequired = isRequiredCustomPropertyIds.has(id);

        if (value &&
            property.type === ECustomPropertyType.SELECT && (
                !property.options ||
                !property.options.find(option => option.id === value)
            )
        ) {
            value = null; // опция удалена
        }

        if (
            !isKnbPinned ||
            isKnbPinned && pinnedOnCard ||
            showCustomProperties.includes(id)
        ) {
            customProperties.push({
                ...property,
                orderNumber: property.orderNumber || 0,
                isRequired,
                value,
                pinned,
                pinnedOnCard
            });
        }
    }
    customProperties.sort((prop1, prop2) => {
        return prop2.orderNumber - prop1.orderNumber; // больший order сверху
    });
    return customProperties;
};

const getDefaultCustomPropertyIds = (
    state: IApplicationState,
    boardId: TBoardId,
): TCustomPropertyId[] => {
    return getBoardCardCustomPropertyOptions(state, boardId).reduce((ids, customProperty) => {
        if (customProperty.isDefault) {
            ids.push(customProperty.option);
        }
        return ids;
    }, []);
}

export const getCustomPropertiesCreateSelector = (
): TgetCustomProperties => createDeepEqualSelector(
    getBoardCardCustomProperties,
    getDefaultCustomPropertyIds,
    getBoardCardRequiredCustomPropertyIds,
    (state: IApplicationState, boardId: TBoardId, cardId: TCardId) => getCardCustomProperties(state, cardId),
    (state: IApplicationState, boardId: TBoardId, cardId: TCardId) => getCardPinnedCustomPropertiesIds(state, cardId),
    (state: IApplicationState, boardId: TBoardId, cardId: TCardId, isKnbPinned: boolean) => isKnbPinned,
    (state: IApplicationState, boardId: TBoardId, cardId: TCardId, isKnbPinned: boolean, showCustomProperties: TCustomPropertyId[]) => showCustomProperties,
    getCustomPropertiesSelector,
);

export const getCustomProperties: TgetCustomProperties = getCustomPropertiesCreateSelector();
